module.exports = __webpack_public_path__ + "static/media/mcc_logo.4fef17d2.png";